import ENV from "../env";
import { buildHeaders, handleExpiredLogin } from "./utils";

/**
 * How far the user got with one lesson; mirrors the backend's LessonStatus. `NOT_STARTED` means no
 * Verification Session was passed, `STARTED` that the first one was and the recap is still due,
 * `FINISHED` that the recap is passed and the lesson needs nothing more.
 */
export type LessonStatus = 'NOT_STARTED' | 'STARTED' | 'FINISHED';

/** Mirrors the backend's ProgressResponse; a lesson the user never verified is absent from `lessons`. */
export type UserProgress = {
    userId: string;
    course: ProgressCourse;
    lessons: Record<string, ProgressLesson>;
};

export type ProgressCourse = {
    id: string;
    name: string;
};

export type ProgressLesson = {
    status: LessonStatus;
    /** The day the recap may be taken; set only while the lesson is started. */
    recapDate: string | null;
    sessions: ProgressSession[];
};

export type ProgressSession = {
    plannedDate: string | null;
    completedDate: string | null;
    completed: boolean;
};

export class UserProgressService {
    static userProgress(courseId: string): Promise<UserProgress> {
        return fetch(`${ ENV.BACKEND }/user-progress/${ courseId }`, {
            method: 'GET',
            headers: buildHeaders()
        })
            .then((response) => handleExpiredLogin(response).json());
    }
}
